import { Order, OrderItem } from 'kiolyn-api';

export interface DSKitchenDisplay {
  id: string;
  name: string;
}

export interface StatusBoardType {
  type: KitchenBoardType;
  name: string;
}

export interface ItemCount {
  id: string;
  name: string;
  count: number;
  selected: boolean;
}

export interface DSItem extends OrderItem {
  kitchen_ready: boolean;
  kitchen_checked: boolean;
  kitchen_selected: boolean;
  status: string;
}

export interface DSOrder extends Order {
  area: string;
  area_name: string;
  items: DSItem[];
  table_name: string;
  customer_name: string;
  persons: number;
}

export enum KitchenBoardType {
  PREPARING = 1,
  READY = 2,
  DONE = 3
}
